<script setup lang="ts">
import { useAttrs, ref, watch, computed } from 'vue'

interface Props {
  editable?: boolean
  modelValue?: object | string
  size?: number
  name?: string
  type?: 'text' | 'password' | 'email' | 'number'
  disabled?: boolean
  maxLength?: number
  placeholder?: string
}

const props = defineProps<Props>()
const emit = defineEmits(['update:modelValue', 'change', 'value-change', 'keypress', 'paste'])
const attrs = useAttrs()

const _value = ref<any>(props.modelValue)

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)
}

const onChange = (event: Event) => {
  emit('value-change', event)
}

const disabled = computed(() => {
  return props.disabled
})

const editable = computed(() => {
  return props.editable
})

const handleKeyPress = (e: KeyboardEvent) => {
  emit('keypress', e)
}
const handlePaste = (e: Event) => {
  emit('paste', e)
}

watch(()=>props.modelValue, (val:any) => {
  _value.value = val
})
</script>

<template>
<!--  {{_value}}-->
  <template v-if="editable">
    <div class="form-control-value">
      {{ _value }}
    </div>
    <InputText
      v-bind="attrs"
      :modelValue="_value"
      :name="props.name"
      type="hidden"
      @input="onInput"
      @change="onChange"
    />
  </template>
  <template v-else>
    <InputText
      v-bind="attrs"
      :modelValue="_value"
      :name="props.name"
      :type="props.type"
      @input="onInput"
      @change="onChange"
      :disabled="disabled"
      @keypress="handleKeyPress"
      @paste="handlePaste"
    />
  </template>
</template>
